import { useEffect } from 'react';
import { unlockNotificationAudio } from '../lib/audio';

export const useUnlockAudioOnInteraction = (): void => {
  useEffect(() => {
    const unlock = () => unlockNotificationAudio();

    document.addEventListener('click', unlock, { once: true });
    document.addEventListener('keydown', unlock, { once: true });

    return () => {
      document.removeEventListener('click', unlock);
      document.removeEventListener('keydown', unlock);
    };
  }, []);
};
